import React, {useState} from 'react';
import {Alert, Button, Card, Form} from 'react-bootstrap';
import ActionBadge from './ActionBadge';

const ACTION_LABELS = {
    invoice_correction: 'Déposez une facture corrigée ou une prise en charge valide',
    info_request: 'Répondez à notre demande d\'informations complémentaires',
};

const ActionFormCard = ({action, onSubmit, submitting, submitResult}) => {
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [comment, setComment] = useState('');
    const [files, setFiles] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await onSubmit({
            invoiceNumber: action.type === 'invoice_correction' ? invoiceNumber : undefined,
            comment: action.type === 'info_request' ? comment : undefined,
            files,
        });
        if (result?.ok) {
            setInvoiceNumber('');
            setComment('');
            setFiles([]);
        }
    };

    if (action.type === 'read_only') {
        return <Alert variant="info">Votre dossier est en cours de traitement. Aucune action n&apos;est attendue de votre part pour le moment.</Alert>;
    }

    return (
        <Card className="mb-4">
            <Card.Header as="h4" className="py-3">Que devez-vous faire ?</Card.Header>
            <Card.Body>
                {ACTION_LABELS[action.type] && (
                    <p className="mb-3">
                        <ActionBadge /> {ACTION_LABELS[action.type]}
                    </p>
                )}
                {submitResult?.ok && <Alert variant="success">Merci, vos informations ont été transmises.</Alert>}
                {submitResult && !submitResult.ok && <Alert variant="danger">Une erreur est survenue lors de l&apos;envoi.</Alert>}

                <Form onSubmit={handleSubmit}>
                    {action.type === 'invoice_correction' && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Nouveau numéro de facture</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={invoiceNumber}
                                    onChange={(e) => setInvoiceNumber(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Joindre la nouvelle facture (optionnel)</Form.Label>
                                <Form.Control type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files))} />
                            </Form.Group>
                        </>
                    )}
                    {action.type === 'info_request' && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Votre réponse</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Joindre des fichiers (optionnel)</Form.Label>
                                <Form.Control type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files))} />
                            </Form.Group>
                        </>
                    )}
                    <Button type="submit" variant="success" disabled={submitting}>
                        {submitting ? 'Envoi…' : 'Envoyer'}
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default ActionFormCard;
